export default "__VITE_ASSET__CK58t1BD__"